/**
 * Downloadable forms for the Career page.
 */
export const careerForms = [
  {
    name: "Ku Nye Employment",
    url: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/download-forms/ku-nye-employment-form.pdf",
  },
  {
    name: "Ku Nye Membership",
    url: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/download-forms/membership-intake-form.pdf",
  },
  {
    name: "Ku Nye Package",
    url: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/download-forms/ku-nye-package-form.pdf",
  },
  {
    name: "Employee Leave Request",
    url: "https://barma-sorig-assets.s3.ap-southeast-2.amazonaws.com/download-forms/employee-leave-request-form.pdf",
  },
];
